// Maintenance Mode Configuration
export const MAINTENANCE_CONFIG = {
  // Set to true to enable maintenance mode
  isMaintenanceMode: false,
  
  // Set to true to show ONLY the maintenance page (overrides everything)
  isCompleteMaintenance: false,
  
  // Features available during maintenance
  allowedFeatures: {
    home: true,
    about: true,
    doctor: true,
    services: false,
    blog: false,
    login: false,
    contact: false,
    admin: false
  },
  
  // Maintenance message
  maintenanceInfo: {
    title: "🔧 Website Under Maintenance",
    message: "We're currently performing scheduled maintenance to improve your experience. Some features are temporarily unavailable.",
    estimatedTime: "2-3 hours",
    availableFeatures: ["Home", "About Us", "Doctor Information"],
    unavailableFeatures: ["Blog", "Services", "Login", "Book Appointment"]
  },
  
  // Emergency contact for complete maintenance
  emergencyContact: "+91 ",
  emergencyEmail: "emergency@sravaniayurdham.com"
};

// Helper function to check if a feature is allowed
export const isFeatureAllowed = (feature) => {
  if (!MAINTENANCE_CONFIG.isMaintenanceMode) return true;
  return MAINTENANCE_CONFIG.allowedFeatures[feature] || false;
};

// Helper function to check if site is in complete maintenance
export const isCompleteMaintenance = () => {
  return MAINTENANCE_CONFIG.isCompleteMaintenance;
};
